/* Progress track and counter for the mobile product slider.
   Layout is pure CSS (the grid becomes a scroll-snap row under 860px); this
   only reflects scroll position, so it stays inert at desktop widths where
   the container never overflows. */
(function () {
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function init(root) {
    // Several sections load this file, so it can execute more than once per
    // page. Without this guard each root would stack duplicate listeners.
    if (root.dataset.sliderReady === 'true') return;

    var track = root.querySelector('[data-slider]');
    var thumb = root.querySelector('[data-slider-thumb]');
    var label = root.querySelector('[data-slider-label]');
    if (!track) return;

    root.dataset.sliderReady = 'true';

    var count = parseInt(root.dataset.sliderCount, 10) || track.children.length;
    if (count < 1) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      // RTL reports scrollLeft as negative in some engines.
      var progress = max > 0 ? Math.min(1, Math.abs(track.scrollLeft) / max) : 0;
      var index = Math.round(progress * (count - 1));

      if (thumb) thumb.style.right = (index / count * 100) + '%';
      if (label) label.textContent = pad(index + 1) + ' / ' + pad(count);
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  var SELECTOR = '[data-product-slider], [data-carousel]';

  document.querySelectorAll(SELECTOR).forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll(SELECTOR).forEach(init);
  });
})();
